module.exports = __webpack_public_path__ + "static/media/memberInformationIcon.e18c12bb.svg";